<template>
    <div :class="context.classes.element" :data-type="context.type">
        <FormulateSlot name="prefix" :context="context">
            <component
                :is="context.slotComponents.prefix"
                v-if="context.slotComponents.prefix"
                :context="context"
            />
        </FormulateSlot>
        <slot></slot>
        <FormulateSlot name="suffix" :context="context">
            <component
                :is="context.slotComponents.suffix"
                v-if="context.slotComponents.suffix"
                :context="context"
            />
        </FormulateSlot>
    </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
}
</script>
